
























































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util'
import AbpBase from '@/lib/abpbase'
import PageRequest from '@/store/entities/page-request'
import HzMailRead from "@/views/sm/hz/hzmailread.vue";
class  PageUserRequest extends PageRequest{
    keyword:string;
    startDate:string;
    endDate:string;
    currentStatus:string="0";
}
@Component({
    components:{HzMailRead}
})
export default class HzMailBoxViews extends AbpBase{
    pagerequest:PageUserRequest=new PageUserRequest();
    loadingInstance:boolean=false;
    readModalShow:boolean=false;
    messageid:string="0";
    titlename:string="";
    isletter:boolean=false;
    get list(){
        return this.$store.state.hzmail.box;
    }
    get loading(){
        return this.$store.state.hzmail.loading;
    }
    get statusList(){
        return [{value:'0',text:'待识别'},{value:'1',text:'已识别'}]
    }
    statusChange(value){
        this.$store.state.hzmail.currentPage=1;
        this.pagerequest.currentStatus=value;
        this.getpage();
    }
    dateChange(value){
        if(value&&value.length==2){
            this.pagerequest.startDate=value[0];
            this.pagerequest.endDate=value[1];
        }
        else{
            this.pagerequest.startDate="";
            this.pagerequest.endDate="";
        }
    }
    find(){
        this.$store.state.hzmail.currentPage=1;
        this.getpage();
    }
    refresh(){
        this.getpage();
    }
    async rowClick (row, column, event) {
        if(row){
            this.messageid=row.id;
            this.titlename=row.mailTitle;
            this.isletter=row.letterId=="0"?true:false;
            this.readModalShow=true;
        }
    }
    pageChange(page:number){
        this.$store.commit('hzmail/setCurrentPage',page);
        this.getpage();
    }
    pagesizeChange(pagesize:number){
        this.$store.commit('hzmail/setPageSize',pagesize);
        this.getpage();
    }
    async getpage(){
        this.pagerequest.maxResultCount=this.pageSize;
        this.pagerequest.skipCount=(this.currentPage-1)*this.pageSize;
        this.loadingInstance=true;
        await this.$store.dispatch({
            type:'hzmail/GetList',
            data:this.pagerequest
        });
        this.loadingInstance=false;
    }
    get pageSize(){
        return this.$store.state.hzmail.pageSize;
    }
    get totalCount(){
        return this.$store.state.hzmail.totalCount;
    }
    get currentPage(){
        return this.$store.state.hzmail.currentPage;
    }
    async created(){
        this.getpage();
    }
}
